export default "__VITE_ASSET__BmlgoexI__"